import { Modal } from '@mui/material';
import {
  Add as AddIcon,
  Assignment,
  Close as CloseIcon,
  Delete,
  Edit,
} from '@mui/icons-material';
import Loading from "components/Loading";
import React, { useState } from "react";
import styled from "styled-components";
import COLOR from "utils/constants/color";

const ListStudentGroup = ({
  open,
  onClose,
  updateState,
  data,
  handleOpenPreview,
  handleDeleteData,
}) => {
  const [deleteLoader, setDeleLoader] = useState("");
  return (
    <div>
      <Modal open={open} onClose={onClose} className="modal-for-rubric">
        <ModalContent orientation={window.screen.orientation?.type}>
          <CloseButton onClick={onClose}>
            <CloseIcon />
          </CloseButton>
          <div className="w-full">
            <div className="heading-label mb-30px">Student Group</div>
            <Wrapper>
              <StyledRubricButton
                onClick={async () => {
                  await updateState({ createGroup: true, open: true });
                }}
              >
                <StyledAddIcon />
                Create Student Group
              </StyledRubricButton>
            </Wrapper>
          </div>
          {data?.length === 0 && (
            <div className="bubbleNotesNoData text-blue-10">
              No data available
            </div>
          )}
          <div className="w-full flex flex-col gap-10px mt-16px overflow-auto px-10px py-10px">
            {data?.map((element, index) => (
              <RubricContainerDiv
                key={index}
                className="flex flex-col items-start cursor-pointer"
              >
                <RubricSubContainerDiv className="flex items-center justify-between w-full">
                  <div className="flex items-center">
                    <Assignment className="mr-10px" />
                    {element?.group_name}
                  </div>

                  <div className="flex gap-10px items-center">
                    <Button onClick={() => handleOpenPreview(index)}>
                      <Edit
                        className="cursor-pointer text-green-10"
                        style={{
                          fontSize: 20,
                          transition: "all 0.3s ease-in-out",
                        }}
                        disabled={deleteLoader}
                      />
                    </Button>

                    <Button
                      onClick={async () => {
                        setDeleLoader(element?.id);
                        await handleDeleteData(element?.id);
                        setDeleLoader(element?.id);
                      }}
                    >
                      {deleteLoader === element?.id ? (
                        <Loading size={16} />
                      ) : (
                        <Delete
                          className="cursor-pointer text-red-10"
                          style={{
                            fontSize: 20,
                            transition: "all 0.3s ease-in-out",
                          }}
                        />
                      )}
                    </Button>
                  </div>
                </RubricSubContainerDiv>
              </RubricContainerDiv>
            ))}
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default ListStudentGroup;

const Button = styled.button`
  background: none;
  border: none;
  outline: none;
  padding: none;
`;

const RubricSubContainerDiv = styled.div`
  padding-inline: 20px;
  padding-top: 4px;
  padding-bottom: 4px;
`;

const RubricContainerDiv = styled.div`
  justify-content: space-between;
  border: 1px solid darkgrey;

  border-radius: 12px;
  align-items: center;

  boxShadow: 0px 0px 10px rgba(0,0,0,0.2);
  transition: all 0.3s ease-in-out;
  &:hover {
  box-shadow: ${(p) => (p.loader ? "" : "0px 0px 10px rgba(0,0,0,0.3)")};
  // transform: scale(1.02);
  },
`;

const RubricButton = styled.button`
  width: 115px;
  height: 34px;

  background-image: linear-gradient(
    to right,
    rgb(3, 152, 158),
    rgb(67, 150, 156)
  );
  color: white;
  border: none;
  border-radius: 6px;
  float: right;
  margin-right: 30px;
  margin-top: -9px;
  cursor: pointer;

  @media (max-width: 600px) {
    margin-right: 46px !important;
    margin-top: 5px !important;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
`;

const StyledAddIcon = styled(AddIcon)`
  margin-right: 2px;
  color: ${COLOR.white};
`;

const StyledRubricButton = styled.button`
  height: 34px;
  background-image: linear-gradient(
    to right,
    rgb(3, 152, 158),
    rgb(67, 150, 156)
  );
  color: white;
  border: none;
  border-radius: 6px;
  padding: 9px;
  margin-top: -9px;
  cursor: pointer;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 600px) {
    margin-right: 46px !important;
    margin-top: 5px !important;
  }
`;

const ModalContent = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  width: ${(props) =>
    props.orientation?.includes("landscape") ? "90%" : "100%"};
  height: ${(props) =>
    props.orientation?.includes("landscape") ? "80%" : "100%"};
  max-width: 39.5rem;
  max-height: 600px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 425px) {
    padding: 5px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgb(204, 80, 71);
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
`;
